const PAGES = {
  home: "/",
  login: "/auth/signin",
  signup: "/signup",
  signupSuccess: "/signup/success",
  resetPassword: "/reset-password",
  createProfile: "/create-profile",
  admin: "/admin",
  profileAdmin: "/admin/profile",
  privacyPolicy: "/privacy-policy",
  termsOfService: "/terms-of-service",
  cookiesPolicy: "/cookies-policy",
  support: "/support/home",
};

export const menuItems = [{
  textKey: "home-page-header-menu-home",
  href: "/#home",
}, {
  textKey: "home-page-header-menu-features",
  href: "/#features",
}, {
  textKey: "home-page-header-menu-use-cases",
  href: "/#use-cases",
}, {
  textKey: "home-page-header-menu-how-it-works",
  href: "/#how-it-works",
}, {
  textKey: "home-page-header-menu-pricing",
  href: "/#pricing",
}, {
  textKey: "home-page-header-menu-faq",
  href: "/#faq",
}, {
  textKey: "home-page-header-menu-blog",
  href: "https://blog.downfor.life/",
}];

export default PAGES;
